module.exports = __webpack_public_path__ + "static/media/Category-Media-Influencers.721d300e.jpg";